import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Skeleton from '../Skeleton';
import { SCREENS } from '../../../constants';

const CardContainer = styled.div`
  ${tw`
    flex
    flex-col
    md:flex-row
    bg-white
    rounded-lg
    overflow-hidden
    border-2
    border-solid
    border-border-default
    shadow-card
    p-1
    mb-6
  `}
  @media (min-width: ${SCREENS.md}) {
    height: calc(200px / 1.4 * 1.2);
  }
`;

const ImageContainer = styled.div`
  ${tw`
    relative
    w-full
  `}
  height: calc(200px / 1.4);
  @media (min-width: ${SCREENS.md}) {
    height: auto;
    width: 42%;
    flex: 0 0 42%;
  }
`;

const ImageSkeleton = styled(Skeleton)`
  ${tw`
    w-full
    h-full
  `}
`;

const ContentContainer = styled.div`
  ${tw`
    w-full
    p-4
    flex
    flex-col
  `}
`;

const Header = styled.div`
  ${tw`
    flex
    flex-col
    gap-1
 w-full max-w-full min-w-0 box-border`}

  @media (min-width: ${SCREENS.md}) {
    ${tw`
      flex-row
      justify-between
      items-start
    `}
  }
`;

const TitleSkeleton = styled(Skeleton)`
  ${tw`
    h-6
    w-40
    mb-2
  `}
`;

const RatingSkeleton = styled(Skeleton)`
  ${tw`
    h-4
    w-36
    mb-2
  `}
`;

const LocationSkeleton = styled(Skeleton)`
  ${tw`
    h-4
    w-52
    mb-4
  `}
`;

const PriceSkeleton = styled(Skeleton)`
  ${tw`
    h-5
    w-20
    mt-auto
    ml-auto
  `}
`;

const BadgeSkeleton = styled(Skeleton)`
  ${tw`
    absolute
    top-2
    left-2
    w-12
    h-6
    rounded-md
  `}
`;

const FavoriteButtonSkeleton = styled(Skeleton)`
  ${tw`
    absolute
    top-2
    right-2
    w-8
    h-8
    rounded-full
  `}
`;

const CarCardSkeleton: React.FC = () => {
  return (
    <CardContainer>
      <ImageContainer>
        <BadgeSkeleton />
        <ImageSkeleton />
        <FavoriteButtonSkeleton />
      </ImageContainer>
      <ContentContainer>
        <Header>
          <TitleSkeleton />
          <RatingSkeleton />
        </Header>
        <LocationSkeleton />
        <PriceSkeleton />
      </ContentContainer>
    </CardContainer>
  );
};

export default CarCardSkeleton;
